// extracted by mini-css-extract-plugin
export var addButton = "_g6-0";
export var border = "_g6-8";
export var check = "_g6-h";
export var danger = "_g6-6";
export var dropdownContainer = "_g6-1";
export var editModalBody = "_g6-j";
export var footerContainer = "_g6-i";
export var fullWidth = "_g6-a";
export var hide = "_g6-9";
export var icon = "_g6-3";
export var input = "_g6-7";
export var inputFlex = "_g6-b";
export var inputWrapper = "_g6-c";
export var manualFocus = "_g6-5";
export var optionButton = "_g6-4";
export var pillWrapper = "_g6-e";
export var pointer = "_g6-2";
export var showOverflow = "_g6-f";
export var tagsFlex = "_g6-d";
export var xButton = "_g6-g";